export class NewRecolementIdNotFoundError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "NewRecolementIdNotFoundError"
    }
}

export class RecolementNotLinkedToItemError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "RecolementNotLinkedToItemError"
    }
}

export class RecolementNotLinkedToAuditCampaignError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "RecolementNotLinkedToAuditCampaignError"
    }
}